import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import BaseUrl from "../../../utils/BaseUrl";
import SwalTopEnd from "../../../utils/swal_top_end";
import ContentPage from "../../Content";
import Select from "react-select";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";

const url = BaseUrl();
const customStyles = {
     
        headRow: {
            style: {
                backgroundColor: '#89214d',
                color: 'white'
            }
        },
        headCells: {
            style: {
                fontSize: '16px',
                fontWeight: '600',
                textTransform: 'uppercase'
            }
        },
        cells: {
            style: {
                fontSize: '15px'
            }
        }
    
}
function AccesUserPage(){

    const [errors,setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [error,setError] = useState();
    const [permissionsList,setPermissions] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [roleData,setRoleData] = useState('');
    const [rolePermission,setRole] = useState([]);
    const [tabCheck,setTabCheck] = useState([]);
    const [users,setUserList] = useState([]);
    const [selectOptionUser,setSelectOptionUser] = useState(null);

    
    const columns = [
        {
          name: 'PERMISSIONS',
          selector: row => row.name,
          sortable: true,
        }, 
      
    ];
    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
    if(user && permissions && !can(permissions,'ACCES UTILISATEURS')){
        navigate('/page-no-found');
    }
    },[user]);

    useEffect(()=>{
        fetchPermissionList();
        fetchDataUsers();
    },[]);


    const fetchDataUsers=async()=>{
        setLoading(true);
        try {
            axios.get(url.base+'/users-list',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
                setLoading(false);
                    setUserList(resp.data.data);
                
            })
        } catch (error) {
            setLoading(false);
        }
    }
    
        const fetchPermissionList = async ()=>{
            setLoading(true);
            try {
                axios.get(url.base+'/permission-list',{
                    headers:{
                        'Content-Type':'application/json',
                        "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                        
                    },
                }).then((resp)=>{
                    setLoading(false);
                    if(resp.status == 200){
                        setPermissions(resp.data.permissionGroups);
                    }
                    
                })
            } catch (error) {
                setLoading(false);
            }
        }
    
        const handleRowSelected =(state) =>{
            // console.log(state.selectedRows);
            setSelectedRows(state.selectedRows);
        };
    
        const submitForm=(e)=>{
            e.preventDefault();
    
            // const permissionTab = selectedRows.map((option)=>option.name);
            // console.log(permissionTab);
           if(selectOptionUser !== null && tabCheck.length > 0){
                const _formData = new FormData();
                _formData.append('permissions', tabCheck );
          
                console.log(_formData);
                setLoading(true);
                try {
                    axios.post(url.base+'/access-users-update/'+selectOptionUser,_formData,
                   {
                       headers:{
                           'Content-Type':'application/json',
                           "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                           
                       },
                       credentials:'include'
                   }
                   ).then((resp)=>{
                      setLoading(false);    
                      SwalTopEnd({icon:"success",title:"Mise à jour effectuée avec succès"});
                    
                      window.location.reload();
                   }).catch((error)=>{
                        console.log(error);
                   })
               } catch (error) {
                    setLoading(false);
                   console.log(error);
               } 
            }else{
             
                SwalTopEnd({icon:"error",title:"Auncune permissions n'a été selectionné."});
              
            }
        }
    
        const rolePermissionSelectedRows = useMemo(()=>{
            return row => rolePermission.includes(row.name)
        },[rolePermission]);


        const handleChangePermissionCheck=(e)=>{

            if(tabCheck.find((list)=> list === e.target.value)){
                const tab = [...tabCheck];
                const itemIndex = tab.findIndex(item => item === e.target.value);
                tab.splice(itemIndex, 1);
    
                setTabCheck(tab);
            }else{
                setTabCheck([...tabCheck,e.target.value]);
            }
        }

            const handleChangeSelectOptionUser=(selectOption)=>{
        setSelectOptionUser(selectOption.value);

        setLoading(true);
        try {
          axios.get(url.base+'/get-user/'+selectOption.value,{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
                setTabCheck(resp.data.permissions);
               
                    fetchPermissionList();
                
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }

    const optionsUser = users?.map((option)=>(({
        value: `${option.id}`,
        label:`${option.name} ${option.last_name}`
    })));

    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Paramètres</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Modification des permissions</p>
                  </a>
                </div>
                {/* <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
                  <i class="mdi mdi-plus-circle"></i> Add Prodcut </button> */}
              </div>
              <div class="header-left">
                <Link class="btn btn-warning mb-2 mb-md-0 mr-2" to="/parametres/others"><i class="mdi mdi-backburger"></i> Retour à la liste</Link>
                {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
              </div>
              
            </div>

            <div class="col-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Modifier les accès des Utilisateurs</h4>
                    {/* <p class="card-description">Tous les champs sont obligatoires</p> */}
                    <form class="row" onSubmit={submitForm}>

                        <div class="col-lg-2 col-12"></div>
                        <div class="col-lg-8 col-12">
                            
                        <div class="card mb-4">
                            
                            <div class="card-body">
                                    
                                
                                <div>
                                    <div class="mb-3">
                                        <label class="form-label">Liste Des Utilisateurs<span className="text-danger">*</span></label>
                                     <Select placeholder="Selectionner un utilisateur" options={optionsUser} onChange={handleChangeSelectOptionUser}/>
                                    </div>

                                    <div class="mb-3">
                                    <div class="table-responsive">
                                        {loading &&
                                            <div class="text-center">
                                            <div class="spinner-border" role="status">
                                            {/* <span class="visually-hidden">Loading...</span> */}
                                            </div>
                                        </div>
                                            }
                                        {!loading && Object.entries(permissionsList).map(([group, permissions]) => (
                                            <div class="card border p-2 mb-2" >
                                                <div class="card-body">
                                                    <h5 class="card-title bg-secondary p-3">{group}</h5>
                                                    <table class="table table-striped">
                                                    {permissions.map((perm, index) => (
                                                        <tr>
                                                            <td>{perm.name}</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td >
                                                                <input type="checkbox" className="form-check-input border-5 border-dark" name="permissions" id="gridCheck2" value={perm.name} onChange={handleChangePermissionCheck} checked={tabCheck.find((list)=> list === perm.name) ? "checked" : ""} disabled={(perm.name === "LISTE DES ROLES ET PERMISSIONS") /**|| (perm.name === "MODIFIER PERMISSIONS") || (perm.name === "AJOUTER PERMISSIONS") **/ ? "disabled" : ""} />
                                                            </td>

                                                        </tr>
                                                    ))}
                                                    </table>
                                                </div>
                                        </div>

                                        ))}
                                        

                                      
                                    </div>
                                    </div>
                                </div>


                            </div>

                            
                            </div>
                            

                            

                            <div class="d-grid">
                            {!loading &&
                                <button type="submit" class="btn btn-primary">
                                    Veuillez Enregistrer la Modification
                                </button>
                            }
                            {loading &&
                            <button class="btn btn-primary" type="button" disabled>
                                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                Enregistrement en cours...
                            </button>
                            }

                        </div>

                        </div>

                        </form>
                  </div>
                </div>
              </div>
            </ContentPage>
        </>
    )
}
export default AccesUserPage;